module.exports = __webpack_public_path__ + "img/ball_3_orange.c4796294.png";